// extracted by mini-css-extract-plugin
export var divider = "_uv-0";